export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
                樱花漫画网 APP
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                下载樱花漫画网专属APP，享受更流畅的下拉式阅读体验。全集漫画免费完整版随时随地想看就看，支持离线缓存、夜间模式、阅读进度同步等实用功能，韩漫日漫国漫一网打尽。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-apple-line text-lg"></i>
                  </div>
                  <span className="text-sm font-medium">App Store 下载</span>
                </a>
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-android-line text-lg"></i>
                  </div>
                  <span className="text-sm font-medium">Android 下载</span>
                </a>
              </div>
              <div className="flex items-center justify-center lg:justify-start gap-4 mt-5 flex-wrap">
                <span className="text-xs text-foreground-500">支持 iOS 15+</span>
                <span className="text-xs text-foreground-500">Android 8.0+</span>
                <span className="text-xs text-foreground-500">完全免费</span>
              </div>
            </div>
            <div className="w-full lg:w-72 p-6 lg:p-0 lg:pr-8 flex justify-center">
              <div className="w-48 lg:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20app%20screenshot%20mockup%20showing%20manga%20reading%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20UI%20design%2C%20vertical%20scrolling%20manga%20reader%2C%20modern%20minimal%20interface%2C%20soft%20warm%20lighting%2C%20Japanese%20comic%20reading%20app%20design&width=560&height=1000&seq=app-preview-08&orientation=portrait"
                  alt="樱花漫画网APP预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}